function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M25 17l-1.4 1.4 5.6 5.6H17v2h12.2l-5.6 5.6L25 33l8-8z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  x: 0.5,
  y: 0.5,
  stroke: "#FFF",
  opacity: 0.254,
  rx: 24
}));

var SvgMoreArrow = function SvgMoreArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OSIgaGVpZ2h0PSI0OSIgdmlld0JveD0iMCAwIDQ5IDQ5Ij4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHBvbHlnb24gZmlsbD0iI0ZGRkZGRiIgcG9pbnRzPSIyNSAxNyAyMy42IDE4LjQgMjkuMiAyNCAxNyAyNCAxNyAyNiAyOS4yIDI2IDIzLjYgMzEuNiAyNSAzMyAzMyAyNSIvPgogICAgPHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiB4PSIuNSIgeT0iLjUiIHN0cm9rZT0iI0ZGRkZGRiIgb3BhY2l0eT0iLjI1NCIgcng9IjI0Ii8+CiAgPC9nPgo8L3N2Zz4K";
export { SvgMoreArrow as ReactComponent };